import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MerchantUserService } from "src/app/services/merchantUser.service";

@Component({
  selector: "app-activate-account",
  templateUrl: "./activate-account.component.html",
  styleUrls: ["./activate-account.component.scss"],
})
export class ActivateAccountComponent implements OnInit {
  OTPFormGroup: FormGroup;
  errorMessage: string;
  showErrorMessage: boolean = false;

  token: string;

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private merchantUserService: MerchantUserService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.token = params["token"];
    });

    this.OTPFormGroup = this.fb.group({
      oldPassword: ["", [Validators.required, Validators.minLength(6)]],
      newPassword: ["", [Validators.required, Validators.minLength(6)]],
    });
  }

  setNewPassword() {
    this.showErrorMessage = false;
    this.errorMessage = "";
    let oldPassword = this.OTPFormGroup.get("oldPassword");
    let newPassword = this.OTPFormGroup.get("newPassword");

    if (!oldPassword.valid || !newPassword.valid) {
      this.showErrorMessage = true;
      this.errorMessage = "Invalid password";
      return;
    }

    if (this.token != "") {
      this.merchantUserService
        .changePasswordWithToken(
          newPassword.value,
          oldPassword.value,
          this.token
        )
        .subscribe(
          (res) => {
            this.router.navigateByUrl("?status=success");
          },
          (err) => {
            this.showErrorMessage = true;
            this.errorMessage = "Հին գաղտնաբառը սխալ է";
          }
        );
    }
  }
}
